import React from "react";

import { StatusBadgeProps } from "./statusBadgeProps";

export const QualifyingStatusBadge = (props: StatusBadgeProps) => {
    const { width, height = "18", viewBox = "0 0 79 18", ...rest } = props;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox={viewBox}
            {...rest}
            data-cy="qualifyingBadge"
        >
            <g
                fill="none"
                fillRule="evenodd"
                stroke="none"
                strokeWidth="1"
                transform="translate(-957 -10126) translate(957 10126)"
            >
                <rect
                    width="79"
                    height="18"
                    x="0"
                    y="0"
                    fill="#7E66D8"
                    rx="2"
                ></rect>
                <path
                    fill="#FFF"
                    fillRule="nonzero"
                    d="M12.337 14l-1.18-1.179c-.595.42-1.348.66-2.246.66C6.237 13.48 5 11.49 5 9.243c0-2.247 1.237-4.231 3.91-4.231 2.68 0 3.917 1.996 3.917 4.243 0 1.085-.298 2.113-.858 2.854l1.179 1.126-.811.765zM8.91 12.296c.554 0 1.01-.135 1.354-.345l-1.209-1.126.818-.747 1.184 1.12c.356-.554.514-1.208.514-1.955 0-1.663-.788-3.047-2.661-3.047-1.862 0-2.656 1.384-2.656 3.047 0 1.67.794 3.053 2.656 3.053zm8.772 1.185c-2.136 0-3.082-1.279-3.082-3.286V5.123h1.255v4.931c0 1.419.444 2.213 1.827 2.213 1.389 0 1.838-.8 1.838-2.224v-4.92h1.255v5.013c0 2.06-.957 3.345-3.093 3.345zm3.899-.111l3.222-8.247h.963l3.21 8.247h-1.354l-.672-1.856h-3.315l-.683 1.856h-1.371zm2.445-2.936h2.527l-1.26-3.485-1.267 3.485zm6.275 2.936V5.123h1.254v7.062h3.607v1.185h-4.861zm6.221 0V5.123h1.255v8.247h-1.255zm3.549 0V5.123h5.755v1.155h-4.5V8.66h3.963v1.155h-3.963v3.555h-1.255zm9.414 0v-3.193l-3.11-5.054h1.517l2.23 3.846 2.24-3.846h1.53l-3.105 5.054v3.193h-1.302zm5.65 0V5.123h1.255v8.247h-1.255zm8.492-8.247h1.203v8.247h-1.267l-3.671-6.187v6.187h-1.208V5.123h1.26l3.683 6.163V5.123zm6.835 8.358c-2.626 0-3.905-1.92-3.905-4.238C66.558 6.92 67.82 5 70.475 5c1.622 0 2.865.805 3.513 2.323l-1.114.467c-.403-1.167-1.273-1.693-2.411-1.693-1.827 0-2.661 1.39-2.661 3.094 0 1.75.793 3.163 2.661 3.163 1.36 0 2.294-.741 2.393-2.142l.03-.216h-1.91V8.981h3.147v4.389h-.998l-.111-1.267c-.473.852-1.384 1.378-2.551 1.378z"
                ></path>
            </g>
        </svg>
    );
};
